import React, {useState} from "react";
import {Box, Button, ClickAwayListener, IconButton, Popover, Switch, Typography, useTheme} from "@mui/material";
import {DynamicFeed} from "@mui/icons-material";
import SvgCustomIcon from "../icons/SvgCustomIcon";
import {Trans} from "@lingui/macro";

const LayerMapButton = React.memo(({layersList,setLayersList,isFormOpen,isPositioning,isPositionSet}) => {
    const paletteItems = [
        {name: 'red', colors: ['#DDB100', '#DD8500', '#DD5800', '#DD2C00', '#DD0000']},
        {name: 'blue', colors: ['#00A0CB', '#0079B8', '#0051A6', '#002A93', '#000280']},
        {name: 'gray', colors: ['#BBBEBF', '#959798', '#6F7171', '#494A4A', '#232323']}
    ];
    const [anchorEl, setAnchorEl] = useState(null)
    const theme = useTheme()

    const handleButtonClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget)
    }

    const open = Boolean(anchorEl)
    const id = open ? 'map-layer-popover' : undefined

    return (
        <Box position='absolute' bottom='185px' right='9px'>
            <Button
                aria-describedby={id}

                onClick={handleButtonClick}
                sx={{
                    backgroundColor: 'white',
                    borderRadius: 0,
                    width: 30,
                    height: 30,
                    boxShadow: 1,
                    border: '1px solid #ccc',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minWidth: 0,
                    padding: 0,
                    '&:hover': {
                        backgroundColor: '#f5f5f5',
                    },
                }}
            >
                {/*<People style={{color: '#333333'}} />*/}
                <SvgCustomIcon  color={'#425B61'} name={'stacks'} size={20}/>
            </Button>

            <ClickAwayListener
                onClickAway={(event) => {
                    if (
                        anchorEl &&
                        anchorEl.contains(event.target)
                    ) {
                        return
                    }
                    setAnchorEl(null)
                }}
            >
                <div>
                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={() => setAnchorEl(null)}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        transformOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        disableAutoFocus
                        disableEnforceFocus
                        disableRestoreFocus
                        disablePortal={true}
                        container={anchorEl}
                    >
                        <Box
                            onClick={(e) => e.stopPropagation()}
                            sx={{
                                padding: 2,
                                backgroundColor: theme.palette.mode === 'light' ? 'white' : 'black',
                                borderRadius: 2,
                                boxShadow: 1,
                                minWidth: 250,
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: 16,
                                    fontWeight: 700,
                                    textAlign: 'center',
                                    mb: 2,
                                    color: theme.palette.mode === 'light' ? 'black' : 'white',
                                    borderBottom: '1px solid #ddd',
                                    pb: 1,
                                }}
                            >
                                <Trans>Additional Data</Trans>
                            </Typography>

                            <Box
                                sx={{
                                    maxHeight: '300px',
                                    overflowY: 'auto',
                                    pr: 1,
                                }}
                            >
                                {layersList.map((layer, i) => {
                                    const paletteName = layer.palette;
                                    const palette = paletteItems.find(p => p.name === paletteName);
                                    const paletteColors = palette ? palette.colors.join(',') : `${layer.color},${layer.color}`;
                                    return (
                                        <Box
                                            key={i}
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                mb: 1,
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    height: '5vh',
                                                    width: '80%',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'flex-start',
                                                    justifyContent: 'flex-start',
                                                }}
                                            >
                                                <Typography
                                                    variant='body2'
                                                    sx={{
                                                        whiteSpace: 'nowrap',
                                                        color:  theme.palette.mode === 'light' ? 'black' : 'white',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                    }}
                                                >
                                                    {layer.title || layer.description} ({layer.fileExtension ? layer.fileExtension : 'geojson'})
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        height: '1vh',
                                                        width: '100%',
                                                        backgroundImage: `linear-gradient(to right, ${paletteColors})`,
                                                    }}
                                                />
                                            </Box>
                                            <Box
                                                sx={{
                                                    height: '5vh',
                                                    width: '20%',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'flex-start',
                                                    justifyContent: 'flex-start',
                                                }}
                                            >
                                                <Switch
                                                    sx={{
                                                        '& .MuiFormControlLabel-label': {
                                                            color: 'black',
                                                        },
                                                    }}
                                                    onClick={(e) => e.stopPropagation()}
                                                    checked={layer.isOpen}
                                                    onChange={(e) => {
                                                        let l = [...layersList.map(l => {
                                                            return { ...l, isFocused: false }
                                                        })];
                                                        const idx = l.findIndex(dt => dt.id === layer.id);
                                                        if (e.target.checked) {
                                                            layer.isOpen = true;
                                                            layer.isFocused = true;
                                                            l.splice(idx, 1, layer);
                                                        } else {
                                                            layer.isOpen = false;
                                                            layer.isLoading = false;
                                                            layer.fileContent = null;
                                                            layer.isLoaded = false;
                                                            l.splice(idx, 1, layer);
                                                        }
                                                        setLayersList(l);
                                                    }}
                                                />
                                            </Box>
                                        </Box>
                                    );
                                })}
                            </Box>
                        </Box>
                    </Popover>

                </div>
            </ClickAwayListener>
        </Box>

    )
})
export default LayerMapButton;